import { P2Accordion, P2Button, P2Checkbox, P2TextLabel } from 'react-bootstrap-common-script'
import { HDBSolicitor, LegalRepresentation } from '../../../models/classes/ApplicationStep3.class';
import HdbSolicitorTNC from './hdb-solicitor-tnc';
import { Separator } from '../../separator';
import { LoanTypeEnum } from '../../../models/enum/loan-type.enum';
import { useCallback, useRef } from 'react';

interface HdbSolicitorFormProps {
  legal_representation?: LegalRepresentation;
  ConveyancingSetFormValue?: Function;
  user_type: string;
  errors?: any;
  variant?: "default" | "conveyancing";
  loan_type?: LoanTypeEnum;
  forceError?: boolean;
}

export default function HdbSolicitorForm({variant="default", ...props }: HdbSolicitorFormProps) {
  const accordionRef = useRef<any>(null);
  const checkReadTnc = useCallback(() => {
    if (props.ConveyancingSetFormValue) {
      let legalRep = new LegalRepresentation({ ...props.legal_representation, hdb_solicitor: new HDBSolicitor({ ...props.legal_representation?.hdb_solicitor, tnc: !props.legal_representation?.hdb_solicitor?.tnc }) })
      props.ConveyancingSetFormValue({ [props.user_type.toString()]: legalRep })
    }
  }, [props.legal_representation]);

  const checkConveyancingSameSolicitor = useCallback(() => {
    if (props.ConveyancingSetFormValue) {
      let legalRep = new LegalRepresentation({ ...props.legal_representation, hdb_solicitor: new HDBSolicitor({ ...props.legal_representation?.hdb_solicitor, represented_same_solicitor: !props.legal_representation?.hdb_solicitor?.represented_same_solicitor }) })
      props.ConveyancingSetFormValue({ [props.user_type.toString()]: legalRep })
    }
  }, [props.legal_representation]);

  const confirmOrEditSolicitor = useCallback(() => {
    if (props.ConveyancingSetFormValue) {
      let represented_same_solicitor = props.loan_type === LoanTypeEnum.no_loan ? true : props.legal_representation?.hdb_solicitor.represented_same_solicitor;
      let legalRep = new LegalRepresentation({ ...props.legal_representation, hdb_solicitor: new HDBSolicitor({ ...props.legal_representation?.hdb_solicitor, is_confirm: !props.legal_representation?.hdb_solicitor?.is_confirm, represented_same_solicitor }) })
      if(props.legal_representation?.hdb_solicitor?.is_confirm !== true){
         accordionRef?.current.toggle();
      }
      props.ConveyancingSetFormValue({ [props.user_type.toString()]: legalRep })
    }
  }, [props.legal_representation]);
  return (
    <div className='polymer-hdb-solicitor-form'>
      <P2Accordion ref={accordionRef} defaultOpen={true} title={<P2TextLabel bold="700" label={"HDB"} />}>
        <>
          <HdbSolicitorTNC/>
          
          <div className='mt-4'>
            <P2Checkbox forceError={props.forceError} variant={props.legal_representation?.hdb_solicitor?.is_confirm ? "disabled" : "default"} isActive={props.legal_representation?.hdb_solicitor?.tnc} onClick={checkReadTnc} description={<P2TextLabel required label={<span className='m-0'>I have read the above Terms & Conditions and agree for HDB to represent me.</span>} />} />
          </div>
          {/* NOTE: This checkbox will only show up when loan type != no loan.
            Therefore, when confirm is clicked, represented_same_solicitor will be set to true by default for no_loan.
          */}
          {(props.loan_type !== LoanTypeEnum.no_loan) && variant === "default" && <>
            <Separator style={{ margin: "24px 0" }} />
            <div>
              <P2Checkbox variant={props.legal_representation?.hdb_solicitor?.is_confirm ? "disabled" : "default"} isActive={props.legal_representation?.hdb_solicitor?.represented_same_solicitor} onClick={checkConveyancingSameSolicitor} description={<P2TextLabel tooltipContent={<span style={{color: "#212529", lineHeight: "1.5rem", fontSize: "1rem"}}>You would be required to engage a lawyer for the following,<div>1) Discharge of current mortgage loan</div><div>2) Obtaining fresh mortgage loan</div><div>3) Conveyancing for the ownership change (current owners)</div><div>4) Conveyancing for the ownership change (proposed owners)</div><br /><div>The change in flat ownership is a conveyancing process. As a recommendation, having the same solicitor acting for the process would expedite and reduce the liaising with multiple parties.</div></span>} hasTooltip label={<span className='m-0'>Conveyancing process is represented by the same lawyer as above.</span>} />} />
            </div>
          </>}

          <div style={{ display: "flex", justifyContent: "flex-start", margin: "32px 0 12px" }} className="polymer-button-wrapper">
            <P2Button disabled={!props.legal_representation?.hdb_solicitor?.tnc} onClick={confirmOrEditSolicitor} variant={"outline-primary"}>{props.legal_representation?.hdb_solicitor?.is_confirm ? "Update details" : "Confirm lawyer"}</P2Button>
          </div>
        </>
      </P2Accordion>
    </div>
  )
}
